/* Ximena Robledo - interacciones */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function initReveal(root) {
    var els = $$('.xr-reveal:not(.is-in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initAnn() {
    $$('[data-xr-ann]').forEach(function (bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var items = $$('.xr-ann__item', bar); if (items.length < 2) return;
      var i = 0; var speed = parseInt(bar.dataset.speed, 10) || 4000;
      setInterval(function () { items[i].classList.remove('is-active'); items[i].setAttribute('aria-hidden', 'true'); i = (i + 1) % items.length; items[i].classList.add('is-active'); items[i].removeAttribute('aria-hidden'); }, speed);
    });
  }

  function findSection(key) {
    return document.querySelector('[id^="shopify-section-"][id$="__' + key + '"]') || document.getElementById('shopify-section-' + key);
  }

  function initTabs() {
    $$('[data-xr-tabs]').forEach(function (tabs) {
      if (tabs.dataset.ready) return; tabs.dataset.ready = '1';
      var btns = $$('[data-xr-tab]', tabs);
      var panels = btns.map(function (b) { return findSection(b.dataset.xrTab); });
      var link = document.querySelector('[data-xr-tab-link="' + tabs.dataset.xrTabs + '"]');
      function show(idx) {
        btns.forEach(function (b, j) {
          var on = j === idx; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
          if (panels[j]) { panels[j].classList.add('xr-tab-panel'); panels[j].hidden = !on; }
        });
        if (link && btns[idx] && btns[idx].dataset.url) link.href = btns[idx].dataset.url;
        window.dispatchEvent(new Event('resize'));
      }
      btns.forEach(function (b, j) { b.addEventListener('click', function () { show(j); }); });
      show(0);
    });
  }

  var T_KEY = 'xrCartTimerStart';
  function tick() {
    if (document.querySelector('[data-xr-cart-empty]') && !document.querySelector('[data-xr-timer]')) { try { sessionStorage.removeItem(T_KEY); } catch (e) {} return; }
    var els = $$('[data-xr-timer]'); if (!els.length) return;
    var mins = parseInt(els[0].dataset.minutes, 10) || 10; var start = 0;
    try { start = parseInt(sessionStorage.getItem(T_KEY), 10) || 0; if (!start) { start = Date.now(); sessionStorage.setItem(T_KEY, String(start)); } } catch (e) { start = start || Date.now(); }
    var left = Math.max(0, mins * 60 - Math.floor((Date.now() - start) / 1000));
    var m = String(Math.floor(left / 60)); if (m.length < 2) m = '0' + m;
    var s = String(left % 60); if (s.length < 2) s = '0' + s;
    els.forEach(function (el) { var t = el.querySelector('[data-xr-timer-value]'); if (t) t.textContent = m + ':' + s; el.classList.toggle('is-expired', left === 0); });
  }

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
    try { return '$ ' + new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100) + ' ' + cur; } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }

  function initRecent() {
    var box = document.querySelector('[data-xr-recent]');
    var cur = document.querySelector('[data-xr-current-product]');
    var handle = cur ? cur.dataset.xrCurrentProduct : null;
    var list = [];
    try { list = JSON.parse(localStorage.getItem('xrRecent') || '[]'); } catch (e) {}
    if (handle) { list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12); try { localStorage.setItem('xrRecent', JSON.stringify(list)); } catch (e) {} }
    if (!box || box.dataset.ready) return; box.dataset.ready = '1';
    var limit = parseInt(box.dataset.limit, 10) || 4;
    var show = list.filter(function (h) { return h !== handle; }).slice(0, limit);
    var section = box.closest('.shopify-section');
    if (!show.length) { if (section) section.hidden = true; return; }
    var grid = box.querySelector('[data-xr-recent-grid]');
    Promise.all(show.map(function (h) { return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (ps) {
      ps.filter(Boolean).forEach(function (p) {
        var a = document.createElement('a'); a.className = 'xr-mini'; a.href = p.url;
        var img = p.featured_image ? String(p.featured_image) : '';
        if (img.indexOf('//') === 0) img = 'https:' + img;
        var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '';
        a.innerHTML = '<span class="xr-mini__img">' + (src ? '<img loading="lazy" alt="" src="' + src + '">' : '') + '</span><span class="xr-mini__title"></span><span class="xr-mini__price">' + (p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '') + money(p.price) + '</span>';
        a.querySelector('.xr-mini__title').textContent = p.title;
        if (img) a.querySelector('img').alt = p.title;
        grid.appendChild(a);
      });
      if (!grid.children.length && section) section.hidden = true;
    });
  }

  function initPopup() {
    var d = document.getElementById('xr-popup');
    if (!d || typeof d.showModal !== 'function' || d.dataset.ready) return; d.dataset.ready = '1';
    var open = function () { try { if (!d.open) d.showModal(); } catch (e) {} };
    var markSeen = function () { try { localStorage.setItem('xrPopupSeen', String(Date.now())); } catch (e) {} };
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-xr-popup-close]')) { d.close(); markSeen(); } });
    d.addEventListener('cancel', markSeen);
    var f = d.querySelector('form'); if (f) f.addEventListener('submit', function () { try { sessionStorage.setItem('xrPopupSent', '1'); } catch (e) {} markSeen(); });
    var sent = null; try { sent = sessionStorage.getItem('xrPopupSent'); } catch (e) {}
    if (sent && (d.querySelector('.xr-popup__code') || d.querySelector('.xr-form-error'))) { try { sessionStorage.removeItem('xrPopupSent'); } catch (e) {} open(); return; }
    if (d.querySelector('.xr-popup__code')) return;
    var seen = 0; try { seen = parseInt(localStorage.getItem('xrPopupSeen'), 10) || 0; } catch (e) {}
    if (seen && Date.now() - seen < 1000 * 60 * 60 * 24 * 7) return;
    setTimeout(function () { if (!document.querySelector('dialog[open]')) open(); }, 9000);
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-xr-open]');
    if (o) { var dlg = document.getElementById(o.dataset.xrOpen); if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); } }
    var c = e.target.closest('[data-xr-close]'); if (c) { var p = c.closest('dialog'); if (p) p.close(); }
    if (e.target.matches && e.target.matches('dialog.xr-drawer')) e.target.close();
  });

  function init(root) { initReveal(root); initAnn(); initTabs(); initRecent(); initPopup(); tick(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  var mo = new MutationObserver(function () { initReveal(document); }); 
  if (document.body) mo.observe(document.body, { childList: true, subtree: true }); else document.addEventListener('DOMContentLoaded', function () { mo.observe(document.body, { childList: true, subtree: true }); });
})();
